"use strict";
/* eslint-disable prefer-spread, @typescript-eslint/consistent-indexed-object-style */
Object.defineProperty(exports, "__esModule", { value: true });
exports.toProtoRpcClient = toProtoRpcClient;
const empty_1 = require("../generated/google/protobuf/empty");
function toProtoRpcClient(orig) {
    const ret = {};
    Object.assign(ret, orig);
    const notify = async (methodName, obj, args) => {
        if (args.length < 2) {
            args.push({});
        }
        else {
            args[1] ??= {};
        }
        args[1].isProtoRpc = true;
        args[1].notification = true;
        await obj[methodName].apply(obj, args);
    };
    const callRpc = (methodName, obj, args) => {
        if (args.length < 2) {
            args.push({});
        }
        else {
            args[1] ??= {};
        }
        args[1].isProtoRpc = true;
        return obj[methodName].apply(obj, args);
    };
    orig.methods.forEach((method) => {
        if (method.O.typeName === empty_1.Empty.typeName) {
            ret[method.name] = (...args) => {
                return notify(method.name, orig, args);
            };
        }
        else {
            ret[method.name] = (...args) => {
                return callRpc(method.name, orig, args).response;
            };
        }
    });
    return ret;
}
//# sourceMappingURL=toProtoRpcClient.js.map